var wpImage = {
  componentDidMount: function() {
    var appName =  'Library/';
      $('img').each(function(){
        var imgsrc = $(this).attr('src');
        var attr = $(this).attr('local');
        // For some browsers, `attr` is undefined; for others,
        // `attr` is false.  Check for both.
        if (typeof attr !== typeof undefined && attr !== false) {
              var imageNewSrc = '//stgcdn.blended.co/app/' + 'blended_v0.0.1-rc0380/App/' + appName + imgsrc;
        if (imgsrc.indexOf('App')>-1) {
        // for stoping the repetion of mixin
        } else {
          $(this).attr('src',  imageNewSrc);      
        }
        }
      })
  },
  componentDidUpdate : function () {
      var appName =  'Library/';
          $('img').each(function(){
            var imgsrc = $(this).attr('src');
            var attr = $(this).attr('local');
            // For some browsers, `attr` is undefined; for others,
            // `attr` is false.  Check for both.
            if (typeof attr !== typeof undefined && attr !== false) {
                  var imageNewSrc = '//stgcdn.blended.co/app/' + 'blended_v0.0.1-rc0380/App/' + appName + imgsrc;
            if (imgsrc.indexOf('App')>-1) {
            // for stoping the repetion of mixin
            } else {
              $(this).attr('src',  imageNewSrc);      
            }
            }
          })
  }
};

module.exports = {wpImage};

//admin|1480656856|5HT8XYi8hsyMA5ilUiulhOlyTyQUrrtNfJqhMHKoHJC|e593aac5316fbe3c5af2330c90629a4bda6fd934de2beb9efda4cbace04d4b11 



  /*
var wpImage = {
  componentDidMount: function() {
    var appName =  'Library/';
    if (this.isWp()) {
      var hostUrl =  this.isWp();
      $('img').each(function(){
        var imgsrc = $(this).attr('src');
        var attr = $(this).attr('local');
        // For some browsers, `attr` is undefined; for others,
        // `attr` is false.  Check for both.
        if (typeof attr !== typeof undefined && attr !== false) {
              var imageNewSrc = hostUrl + 'wp-content/themes/blended_fw/App/' + appName + imgsrc;
	      if (imgsrc.indexOf('wp-content')>-1) {
				// for stoping the repetion of mixin
	      } else {
		      $(this).attr('src',  imageNewSrc);			
	      }
        }
      })
    }
  },
  isWp : function () {
    if ( document.location.href.indexOf('wp-admin') > -1 ) {
       return (window.location.href).split("wp-admin")[0]
     } else {
      return false;
     }
  },
  componentDidUpdate : function () {
      var appName =  'Library/';
        if (this.isWp()) {
          var hostUrl =  this.isWp();
          $('img').each(function(){
            var imgsrc = $(this).attr('src');
            var attr = $(this).attr('local');
            // For some browsers, `attr` is undefined; for others,
            // `attr` is false.  Check for both.
            if (typeof attr !== typeof undefined && attr !== false) {
                  var imageNewSrc = hostUrl + 'wp-content/themes/blended_fw/App/' + appName + imgsrc;
            if (imgsrc.indexOf('wp-content')>-1) {
            // for stoping the repetion of mixin
            } else {
              $(this).attr('src',  imageNewSrc);      
            }
            }
          })
        }
  }
};

module.exports = {wpImage};

//admin|1480656856|5HT8XYi8hsyMA5ilUiulhOlyTyQUrrtNfJqhMHKoHJC|e593aac5316fbe3c5af2330c90629a4bda6fd934de2beb9efda4cbace04d4b11 */




/** WEBPACK FOOTER **
 ** ./html/wpImage.js
 **/